export function BallotBoxIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M7.5 8.5L11.5 4.5L15 8L11 12L7.5 8.5Z" />
      <path d="M12.5 5.5L15.5 3C16.5 2.2 18 2.5 18.8 3.5L19.5 4.5C20.2 5.5 20 7 19 7.8L16 10" />
      <rect x="4" y="10" width="16" height="2.5" rx="0.5" fill="currentColor" />
      <rect x="5.5" y="12.5" width="13" height="9" rx="0.5" />
      <polygon
        points="12,14.5 12.7,16 14.3,16.2 13.1,17.4 13.4,19 12,18.2 10.6,19 10.9,17.4 9.7,16.2 11.3,16"
        fill="currentColor"
        stroke="none"
      />
    </svg>
  );
}
